module.exports = __webpack_public_path__ + "img/Alternatives scoping-Impact characterisation.64cc644f.svg";